export type NumberSeparators = {
  decimal: string
  group: string
}

export const getNumberSeparators = (locale: string): NumberSeparators => {
  const parts = new Intl.NumberFormat(locale).formatToParts(1234567.1)
  return {
    decimal: parts.find(part => part.type === 'decimal')?.value ?? '.',
    group: parts.find(part => part.type === 'group')?.value ?? ','
  }
}

const UNICODE_MINUS = '\u2212'

/**
 * Parses a localized displayed number (e.g. "1 234,5 %") and converts it back to its stored value.
 * Returns NaN when the input does not contain a number, so that the input falls back to its last valid value.
 */
export const parseLocaleNumber = (input: string, separators: NumberSeparators, scaleExponent = 0) => {
  const normalized = input
    .replaceAll(UNICODE_MINUS, '-')
    .replaceAll(separators.group, '')
    .replaceAll(separators.decimal, '.')
    .replace(/[^0-9.-]/g, '')

  if (!/\d/.test(normalized)) {
    return Number.NaN
  }

  const displayedValue = Number(normalized)
  // toPrecision removes floating point noise introduced by the division (e.g. 12.3 / 100)
  return Number((displayedValue / 10 ** scaleExponent).toPrecision(15))
}
